import { addServices, qryAddServicesProdList } from '@pages/AddServices/services';
import cloneDeep from 'lodash/cloneDeep';
import { getRequestData } from '@/utils';

const defaultState = {
  step: 0, // 加装业务流程的步骤
  searchCustInfo: {}, // 从搜索页面同步过来的用户信息
  serviceType: {}, // 从搜索页面同步过来的服务类型
  subServiceType: {}, // 从搜索页面同步过来的子服务类型
  addServiceSubTypeList: [], // 第四步，可加装的自服务类型列表
  serviceAddition: {}, // 第四步存储的数据
  offerSelectionDetail: {}, // 第五步存储的数据
};

export default {
  namespace: 'addServices',
  state: cloneDeep(defaultState),
  effects: {
    // 加装
    *addServices({ payload }, { call }) {
      const response = yield call(addServices, payload);
      return getRequestData(response, false);
    },
    *qryAddServicesProdList({ payload }, { call, put }) {
      const response = yield call(qryAddServicesProdList, payload);
      const { objServiceSubTypeDtoList } = getRequestData(response);
      yield put({
        type: 'save',
        payload: { addServiceSubTypeList: objServiceSubTypeDtoList || [] },
      });
    },
  },

  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
    clear() {
      return cloneDeep(defaultState);
    },
  },
};
